// Auto-clear old wishlist data
var wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');
if (wishlist.length > 0 && !wishlist[0].url) {
  localStorage.removeItem('wishlist');
}

function toggleWishlist(btn, productId) {
  var wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');
  var card = btn.closest('.custom-card-wrapper');
  var title = card.querySelector('.card__heading a') ? card.querySelector('.card__heading a').innerText : '';
  var url = card.querySelector('.card__heading a') ? card.querySelector('.card__heading a').getAttribute('href') : '';
  var image = card.querySelector('img') ? card.querySelector('img').getAttribute('src') : '';
  var price = card.querySelector('.price') ? card.querySelector('.price').innerText : '';

  var index = wishlist.findIndex(function(i) { return i.id == productId; });

  if (index === -1) {
    wishlist.push({ id: productId, title: title, url: url, image: image, price: price });
    btn.classList.add('wishlisted');
  } else {
    wishlist.splice(index, 1);
    btn.classList.remove('wishlisted');
  }

  localStorage.setItem('wishlist', JSON.stringify(wishlist));
  updateWishlistBadge();
}

function updateWishlistBadge() {
  var wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');
  var badge = document.getElementById('wishlist-badge');
  if (badge) {
    if (wishlist.length > 0) {
      badge.style.display = 'flex';
      badge.innerText = wishlist.length;
    } else {
      badge.style.display = 'none';
    }
  }
}

document.addEventListener('DOMContentLoaded', updateWishlistBadge);